import {
  Component,
  Renderer2,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { filter, tap, distinctUntilChanged, takeUntil } from 'rxjs/operators';

// INTERFACES
import { OptionInterface } from '../../../shared/interfaces';

@Component({
  selector: 'lum-ui-advance-select',
  templateUrl: './ui-advance-select.component.html',
  styleUrls: ['./ui-advance-select.component.scss'],
})
export class UiAdvanceSelectComponent implements OnInit, OnDestroy {
  @Input()
  type :'primary' | 'secondary' | 'tertiary' = 'primary';

  @Input()
  disabled :boolean = false;

  @Input()
  size :'small' | 'medium' | 'large' = 'medium';

  @Input()
  items :OptionInterface[] = [];

  /**
   * Select contents
   *
   * @required
   */
  @Input()
  placeholder :string = '';

  @Input()
  selectedOption :OptionInterface | null = null;

  @Input()
  loading :boolean = false;

  @Output()
  selectOptionEvent = new EventEmitter<OptionInterface>();

  @Output()
  openedChange = new EventEmitter<boolean>();

  @ViewChild('toggleButton')
  toggleButton :ElementRef | undefined;

  @ViewChild('menu')
  menu :ElementRef | undefined;

  isToggled :boolean = false;
  private onDestroy$ = new Subject();

  ngOnInit() :void {
    this.subscribeKeyEvent();
  }
  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private subscribeKeyEvent() :void {
    fromEvent(document, 'keydown')
      .pipe(
        filter((e :any) => e.keyCode === 27),
        tap((escpress :KeyboardEvent) => {
          if (escpress.type === 'keydown') {
            this.isToggled = false;
          }
        }),
        distinctUntilChanged(),
        takeUntil(this.onDestroy$),
      )
      .subscribe();
  }

  constructor(private renderer :Renderer2) {
    this.renderer.listen('window', 'click', (e :Event) => {
      if (
        e.target !== this.toggleButton?.nativeElement &&
        e.target !== this.menu?.nativeElement
      ) {
        this.isToggled = false;
      }
    });
  }

  toggleSelect() :void {
    if (!this.disabled) {
      this.isToggled = !this.isToggled;

      // TODO: CONVERT TO OBSERVABLE `isToggled`
      if (this.isToggled) {
        this.openedChange.emit(true);
      }
    }
  }

  itemSelect(option :OptionInterface | null) :void {
    this.selectedOption = option;
    this.selectOptionEvent.emit(
      option || {
        value: null,
        label: '',
      },
    );
    this.isToggled = false;
  }

  get classes() :string[] {
    const mode = `lum-advance-select--${this.type}`;

    return [
      'lum-advance-select',
      `lum-advance-select--${this.size}`,
      mode,
      this.disabled ? 'disabled' : '',
      this.isToggled ? 'open' : '',
    ];
  }
}
